import { Component, NgZone, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import AOS from 'aos';
import idleTimeout from 'idle-timeout';
import { AuthenticationService } from './shared/services/auth/authentication.service';

const IDLE_TIMEOUT_MS = 1000 * 60 * 10;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'PPDMS';

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    this.initIdleTimeout();
    this.initAOS();
  }

  initIdleTimeout() {
    const instance = idleTimeout(
      (element, timeout) => {
        console.log(`Idle state detected on ${element} after ${timeout} ms`);

        if(!this.authenticationService.isAuthenticated) return;
        this.authenticationService.logout();
      },
      {
        element: document,
        timeout: IDLE_TIMEOUT_MS,
        loop: false,
      },
    );
  }

  initAOS() {
    if (typeof window === 'undefined') return; // SSR guard
    this.ngZone.runOutsideAngular(() => {
      AOS.init({
        // Keep these
        startEvent: 'DOMContentLoaded',
        initClassName: 'aos-init',
        animatedClassName: 'aos-animate',
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        easing: 'ease',
        anchorPlacement: 'top-bottom',

        // Your changes
        once: true,
        mirror: false,
        offset: 50,
        duration: 800,
        throttleDelay: 16,
        delay: 0,
      });
    });
  }
}
